import React, { useEffect, useState } from "react";
import "../Style/ShowAllCourses.css";
import judicialLogo from "../Images/judicialLogo.png";
import { useDispatch, useSelector } from "react-redux";
import {
    deleteCourse,
    deleteFileFromCourse,
    deleteFolderFromCourse,
    getAllCourses,
    openCreateCourseDialog,
    openCreateNewCourseDialog,
    openEditCourseDialog,
    selectedCourse,
} from "../Redux/Dashboard/DashboardSlice";
import Spinner from "../Spinner/Spinner";
import { FaFolder, FaFilePdf, FaVideo, FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Notify } from "../CommonPopup/DashboardPopUp";

const ShowAllCourses = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selector = useSelector((s) => s.DashboardSlice);
    const coursesData = selector.coursesData;
    console.log("coursesData:", coursesData);

    const loader = selector.loader;

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showDeleteFileDialog, setShowDeleteFileDialog] = useState(false);
    const [showDeleteCourseDialog, setShowDeleteCourseDialog] = useState(false);
    const [selectedFolderId, setSelectedFolderId] = useState(null);
    const [selectedFileId, setSelectedFileId] = useState(null);
    console.log("selectedFileId:", selectedFileId);

    const [deleteType, setDeleteType] = useState("folder"); // or "file"

    const [isPaid, setIsPaid] = useState("");
    const [category, setCategory] = useState([]);
    const [type, setType] = useState([]);
    const [readMoreStates, setReadMoreStates] = useState({});

    const toggleReadMore = (index) => {
        setReadMoreStates((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const handleDelete = () => {
        if (deleteType === "folder" || "subfolder" || "IsSubfolder") {
            dispatch(deleteFolderFromCourse({ folderId: selectedFolderId }))
                .unwrap()
                .then((data) => {
                    Notify({ data: "success", msg: data.message || "Folder deleted successfully", type: "success" });
                    dispatch(getAllCourses({ isPaid: "" }));
                })
                .catch((err) => {
                    Notify({ data: "error", msg: err || "Folder not deleted" });
                });
        }

        // Close the delete dialog
        setShowDeleteDialog(false);
    };

    const handleDeleteFile = () => {
        if (selectedFileId) {
            dispatch(deleteFileFromCourse({ fileId: selectedFileId }))
                .unwrap()
                .then((data) => {
                    Notify({ data: "success", msg: data.message || "File deleted successfully", type: "success" });
                    dispatch(getAllCourses({ isPaid: "" }));
                })
                .catch((err) => {
                    Notify({ data: "error", msg: err || "File not deleted" });
                });
        }

        // Close the delete dialog
        setShowDeleteFileDialog(false);
    };


    const handleCourseDelete = () => {
        if (selectedFolderId) {
            dispatch(deleteCourse(selectedFolderId)).unwrap();
            Notify({ data: "success", msg: "Course Deleted successfully", type: "success" });

            dispatch(getAllCourses({ isPaid: "" }));
            navigate("/allCourses");
            setShowDeleteCourseDialog(false);
        }

    };

    const openDeleteDialog = (id, type) => {
        setSelectedFolderId(id);
        setDeleteType(type); // "file" or "folder"
        setShowDeleteDialog(true);
    };

    const openDeleteFileDialog = (id, type) => {
        setSelectedFileId(id);
        setDeleteType(type); // "file" or "folder"
        setShowDeleteFileDialog(true);
    };

    const openDeleteCourseDialog = (id) => {
        setSelectedFolderId(id);
        setShowDeleteCourseDialog(true);
    };

    useEffect(() => {
        dispatch(getAllCourses({ is_paid: isPaid, category, type }));
    }, [dispatch, isPaid, category, type]);

    const handleAddFiles = (course) => {
        dispatch(openCreateCourseDialog(true));
        dispatch(selectedCourse({ course }));
    };

    const FolderView = ({ folder, openDeleteDialog, isSubfolder = false }) => {
        const [isOpen, setIsOpen] = useState(false);
        const handleToggle = () => setIsOpen(!isOpen);

        return (
            <div className={`folder-container-1 ${isSubfolder ? "subfolder" : ""}`}>
                <div className="folder">
                    <span onClick={handleToggle} style={{ cursor: "pointer" }}>
                        <FaFolder className="folder-icon" />
                        {folder.folder_name}
                    </span>
                    <FaTrash
                        className="delete-icon"
                        title={`Delete ${isSubfolder ? "Subfolder" : "Folder"}`}
                        onClick={() => {
                            openDeleteDialog(folder.id, isSubfolder ? "subfolder" : "folder");
                        }}
                    />
                </div>

                {isOpen && (
                    <div className="folder-content">
                        {/* Render Files */}
                        {folder.files?.map((file) => {
                            const isPdf = file.name.toLowerCase().endsWith(".pdf");
                            const isVideo = /\.(mp4|mov|avi|mkv)$/i.test(file.name);

                            return (
                                <div key={file.id} className="file">
                                    {isPdf ? (
                                        <FaFilePdf className="file-icon" />
                                    ) : isVideo ? (
                                        <FaVideo className="file-icon" />
                                    ) : (
                                        <FaFilePdf className="file-icon" />
                                    )}
                                    <a
                                        href={file.s3_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {file.name}
                                    </a>
                                    <FaTrash
                                        className="delete-icon"
                                        title="Delete File"
                                        onClick={() => openDeleteFileDialog(file.id, "file")}
                                    />
                                </div>
                            );
                        })}

                        {/* Render Subfolders */}
                        {folder.subfolders?.map((subfolder) => (
                            <FolderView
                                key={subfolder.id}
                                folder={subfolder}
                                openDeleteDialog={openDeleteDialog}
                                isSubfolder={true}
                            />
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="AllCoursesMain">
            <img src={judicialLogo} alt="Judicial Logo" className="homeJudicialLogoAllCourses" />

            <button
                className="create-course-btn"
                onClick={() => dispatch(openCreateNewCourseDialog(true))}
            >
                + Create New Course
            </button>

            <div className="filters-container">
                <div className="filter-group">
                    <label className="filter-label">Price:</label>
                    <div className="filter-buttons">
                        {["All", "Paid", "Free"].map((label, idx) => {
                            const value = label === "All" ? "" : label === "Paid" ? "true" : "false";
                            return (
                                <button
                                    key={idx}
                                    className={`filter-btn ${isPaid === value ? "active" : ""}`}
                                    onClick={() => setIsPaid(value)}
                                >
                                    {label}
                                </button>
                            );
                        })}
                    </div>
                </div>

                <div className="filter-group">
                    <label className="filter-label">Category:</label>
                    <div className="filter-buttons">
                        {["CLAT/LAW", "Judiciary", "Govt. Jobs"].map((cat) => (
                            <button
                                key={cat}
                                className={`filter-btn ${category.includes(cat) ? "active" : ""}`}
                                onClick={() =>
                                    setCategory((prev) =>
                                        prev.includes(cat) ? prev.filter((c) => c !== cat) : [...prev, cat]
                                    )
                                }
                            >
                                {cat}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="filter-group">
                    <label className="filter-label">Type:</label>
                    <div className="filter-buttons">
                        {["Courses", "Video", "Test"].map((t) => (
                            <button
                                key={t}
                                className={`filter-btn ${type.includes(t) ? "active" : ""}`}
                                onClick={() =>
                                    setType((prev) =>
                                        prev.includes(t) ? prev.filter((c) => c !== t) : [...prev, t]
                                    )
                                }
                            >
                                {t}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {loader ? (
                <Spinner />
            ) : coursesData && coursesData.length > 0 ? (
                <div className="courses-container">
                    {coursesData.map((course, courseIndex) => {
                        const isReadMore = readMoreStates[courseIndex] || false;
                        return (
                            <div key={courseIndex} className="course-container">
                                <div className="course-header">
                                    <h3>{course.title?.replace(/^"|"$/g, "")}</h3>
                                </div>

                                {course.thumbnail && (
                                    <img
                                        src={course.thumbnail}
                                        alt="Course Thumbnail"
                                        className="course-thumbnail"
                                    />
                                )}

                                <p className="course-description">
                                    {isReadMore
                                        ? course.description?.replace(/^"|"$/g, "")
                                        : `${course.description?.replace(/^"|"$/g, "").slice(0, 120)}...`}
                                    {course.description?.length > 120 && (
                                        <span
                                            className="read-more-toggle"
                                            onClick={() => toggleReadMore(courseIndex)}
                                        >
                                            {isReadMore ? " Read Less" : " Read More"}
                                        </span>
                                    )}
                                </p>
                                <button
                                    className="add-file-button"
                                    onClick={() => handleAddFiles(course)}
                                >
                                    + Add Files
                                </button>
                                <div className="d-flex">

                                    <button
                                        className="edit-course-button"
                                        onClick={() => {
                                            dispatch(selectedCourse({ course }));
                                            dispatch(openEditCourseDialog(true));
                                        }}
                                    >
                                        <FaEdit />
                                        Edit Course
                                    </button>
                                    <button
                                        className="delete-course-button"
                                        onClick={() => openDeleteCourseDialog(course._id)}
                                        title="Delete Course"
                                    >
                                        <FaTrash />
                                        Delete Course
                                    </button>
                                </div>

                                {Array.isArray(course.content?.structure) && course.content.structure.length > 0 ? (
                                    course.content.structure.map((folder) => (
                                        <FolderView key={folder._id} folder={folder} openDeleteDialog={openDeleteDialog} courseId={course._id} />

                                    ))
                                ) : (
                                    <p className="no-modules">No folders found in this course.</p>
                                )}
                                {Array.isArray(course.content?.files) && course.content.files.length > 0 && (
                                    <div className="course-files">
                                        {course.content.files.map((file, fileIndex) => (
                                            <div key={fileIndex} className="file">
                                                <FaFilePdf className="file-icon" />
                                                <a
                                                    href={file.s3_url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {file.name}
                                                </a>
                                                <FaTrash
                                                    className="delete-icon"
                                                    title="Delete File"
                                                    onClick={() => openDeleteDialog(file.id)}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            ) : (
                <p className="text-center no-courses">No courses found matching the criteria.</p>
            )}

            {/* Delete Course Dialog */}
            <Modal show={showDeleteCourseDialog} centered>
                <Modal.Body className="text-center">
                    <h5 className="mt-3">Are you sure you want to delete this Course?</h5>
                    <hr />
                    <p className="my-5">This action will permanently remove it from the database.</p>
                    <div className="d-flex justify-content-center mb-3">
                        <Button variant="secondary" className="me-3" onClick={() => setShowDeleteCourseDialog(false)}>Cancel</Button>
                        <Button variant="danger" onClick={handleCourseDelete}>Delete</Button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Delete Folder Dialog */}
            <Modal show={showDeleteDialog} centered>
                <Modal.Body className="text-center">
                    <h5 className="mt-3">Are you sure you want to delete this Folder?</h5>
                    <hr />
                    <p className="my-5">This action will permanently remove it from the database.</p>
                    <div className="d-flex justify-content-center mb-3">
                        <Button variant="secondary" className="me-3" onClick={() => setShowDeleteDialog(false)}>Cancel</Button>
                        <Button variant="danger" onClick={handleDelete}>Delete</Button>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Delete file Dialog */}
            <Modal show={showDeleteFileDialog} centered>
                <Modal.Body className="text-center">
                    <h5 className="mt-3">Are you sure you want to delete this File?</h5>
                    <hr />
                    <p className="my-5">This action will permanently remove it from the database.</p>
                    <div className="d-flex justify-content-center mb-3">
                        <Button variant="secondary" className="me-3" onClick={() => setShowDeleteFileDialog(false)}>Cancel</Button>
                        <Button variant="danger" onClick={handleDeleteFile}>Delete</Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default ShowAllCourses;






//*****************************************Withour Edit Course and Delete folder and files****************************************************** */
// import React, { useEffect, useState } from "react";
// import "../Style/ShowAllCourses.css";
// import judicialLogo from "../Images/judicialLogo.png";
// import { useDispatch, useSelector } from "react-redux";
// import {
//     getAllCourses,
//     openCreateCourseDialog,
//     openCreateNewCourseDialog,
//     selectedCourse,
// } from "../Redux/Dashboard/DashboardSlice";
// import Spinner from "../Spinner/Spinner";
// import { FaFolder, FaFilePdf, FaVideo, FaEdit, FaTrash } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// const ShowAllCourses = () => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const selector = useSelector((s) => s.DashboardSlice);
//     const coursesData = selector.coursesData;
//     const loader = selector.loader;

//     // Filters
//     const [isPaid, setIsPaid] = useState("");
//     const [category, setCategory] = useState([]);
//     const [type, setType] = useState([]);
//     const [readMoreStates, setReadMoreStates] = useState({});
//     const toggleReadMore = (index) => {
//         setReadMoreStates((prev) => ({
//             ...prev,
//             [index]: !prev[index],
//         }));
//     };


//     useEffect(() => {
//         dispatch(getAllCourses({ is_paid: isPaid, category, type }));
//     }, [dispatch, isPaid, category, type]);

//     const handleAddFiles = (course) => {
//         dispatch(openCreateCourseDialog(true));
//         dispatch(selectedCourse({ course }));
//     };

//     // 📌 Nested Folder View Component (Inside the same file)
//     const FolderView = ({ folder }) => {
//         const [isOpen, setIsOpen] = useState(false);

//         const handleToggle = () => {
//             setIsOpen(!isOpen);
//         };

//         return (
//             <div className="folder-container-1">
//                 <div className="folder" onClick={handleToggle}>
//                     <FaFolder className="folder-icon" />
//                     {folder.folder_name}
//                 </div>

//                 {isOpen && (
//                     <div className="folder-content">
//                         {/* Files */}
//                         {folder.files?.map((file) => {
//                             const isPdf = file.name.toLowerCase().endsWith(".pdf");
//                             const isVideo = /\.(mp4|mov|avi|mkv)$/i.test(file.name);

//                             return (
//                                 <div key={file._id} className="file">
//                                     {isPdf ? (
//                                         <FaFilePdf className="file-icon" />
//                                     ) : isVideo ? (
//                                         <FaVideo className="file-icon" />
//                                     ) : (
//                                         <FaFilePdf className="file-icon" /> // fallback or use FaFile
//                                     )}
//                                     <a href={file.s3_url} target="_blank" rel="noopener noreferrer">
//                                         {file.name}
//                                     </a>
//                                 </div>
//                             );
//                         })}


//                         {/* Subfolders */}
//                         {folder.subfolders?.map((subfolder) => (
//                             <FolderView key={subfolder._id} folder={subfolder} />
//                         ))}
//                     </div>
//                 )}
//             </div>
//         );
//     };

//     return (
//         <div className="AllCoursesMain">
//             <img src={judicialLogo} alt="Judicial Logo" className="homeJudicialLogoAllCourses" />

//             <button
//                 className="create-course-btn"
//                 onClick={() => dispatch(openCreateNewCourseDialog(true))}
//             >
//                 + Create New Course
//             </button>

//             {/* Filters */}
//             <div className="filters-container">
//                 {/* Price Filter */}
//                 <div className="filter-group">
//                     <label className="filter-label">Price:</label>
//                     <div className="filter-buttons">
//                         {["All", "Paid", "Free"].map((label, idx) => {
//                             const value = label === "All" ? "" : label === "Paid" ? "true" : "false";
//                             return (
//                                 <button
//                                     key={idx}
//                                     className={`filter-btn ${isPaid === value ? "active" : ""}`}
//                                     onClick={() => setIsPaid(value)}
//                                 >
//                                     {label}
//                                 </button>
//                             );
//                         })}
//                     </div>
//                 </div>

//                 {/* Category Filter */}
//                 <div className="filter-group">
//                     <label className="filter-label">Category:</label>
//                     <div className="filter-buttons">
//                         {["CLAT/LAW", "Judiciary", "Govt. Jobs"].map((cat) => (
//                             <button
//                                 key={cat}
//                                 className={`filter-btn ${category.includes(cat) ? "active" : ""}`}
//                                 onClick={() =>
//                                     setCategory((prev) =>
//                                         prev.includes(cat)
//                                             ? prev.filter((c) => c !== cat)
//                                             : [...prev, cat]
//                                     )
//                                 }
//                             >
//                                 {cat}
//                             </button>
//                         ))}
//                     </div>
//                 </div>

//                 {/* Type Filter */}
//                 <div className="filter-group">
//                     <label className="filter-label">Type:</label>
//                     <div className="filter-buttons">
//                         {["Courses", "Video", "Test"].map((t) => (
//                             <button
//                                 key={t}
//                                 className={`filter-btn ${type.includes(t) ? "active" : ""}`}
//                                 onClick={() =>
//                                     setType((prev) =>
//                                         prev.includes(t)
//                                             ? prev.filter((c) => c !== t)
//                                             : [...prev, t]
//                                     )
//                                 }
//                             >
//                                 {t}
//                             </button>
//                         ))}
//                     </div>
//                 </div>
//             </div>

//             {/* Loader & Courses */}
//             {loader ? (
//                 <Spinner />
//             ) : coursesData && coursesData.length > 0 ? (




//                 <div className="courses-container">
//                     {coursesData.map((course, courseIndex) => {
//                         const isReadMore = readMoreStates[courseIndex] || false;

//                         return (
//                             <div key={courseIndex} className="course-container">
//                                 {/* 📸 Thumbnail */}
//                                 {course.thumbnail && (
//                                     <img
//                                         src={course.thumbnail}
//                                         alt="Course Thumbnail"
//                                         className="course-thumbnail"
//                                     />
//                                 )}

//                                 {/* 🏷 Title */}
//                                 <h3>{course.title?.replace(/^"|"$/g, "")}</h3>

//                                 {/* 📄 Description with Read More */}
//                                 <p className="course-description">
//                                     {isReadMore
//                                         ? course.description?.replace(/^"|"$/g, "")
//                                         : `${course.description?.replace(/^"|"$/g, "").slice(0, 120)}...`}
//                                     {course.description?.length > 120 && (
//                                         <span
//                                             className="read-more-toggle"
//                                             onClick={() => toggleReadMore(courseIndex)}
//                                         >
//                                             {isReadMore ? " Read Less" : " Read More"}
//                                         </span>
//                                     )}
//                                 </p>

//                                 {/* ➕ Add File Button */}
//                                 <button
//                                     className="add-file-button"
//                                     onClick={() => handleAddFiles(course)}
//                                 >
//                                     + Add Files
//                                 </button>

//                                 {/* 📁 Folder Structure */}
//                                 {Array.isArray(course.content?.structure) && course.content.structure.length > 0 ? (
//                                     course.content.structure.map((folder) => (
//                                         <FolderView key={folder._id} folder={folder} />
//                                     ))
//                                 ) : (
//                                     <p className="no-modules">No folders found in this course.</p>
//                                 )}

//                                 {/* 📂 Root Files */}
//                                 {Array.isArray(course.content?.files) && course.content.files.length > 0 && (
//                                     <div className="course-files">
//                                         {course.content.files.map((file, fileIndex) => (
//                                             <div key={fileIndex} className="file">
//                                                 <FaFilePdf className="file-icon" />
//                                                 <a
//                                                     href={file.s3_url}
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                 >
//                                                     {file.name}
//                                                 </a>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 )}
//                             </div>
//                         );
//                     })}


//                 </div>
//             ) : (
//                 <p className="text-center no-courses">No courses found matching the criteria.</p>
//             )}
//         </div>
//     );
// };

// export default ShowAllCourses;
